import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";
import { CMS_SLUG_CONSTANTS } from "../../../constants/optimize-constants";
import { getSellerTypeStyle, PLATFORMS, STYLE_COMPONENTS, STYLE_KEYS } from "../../../constants/app-constants";

const WhyChooseThisCar = ({ content, config, isLuxuryCar, cmsConfig}) => {
    const {overview: {features} = {}} = content || {};
    const {isDealerListing} = getCarInfo(content);
    if (!features?.length) {
        return null;
    }
    if (isDealerListing) {
        return null;
    }

    const section = getPageSectionByName(cmsConfig?.data?.pageSections, CMS_SLUG_CONSTANTS.WHY_CHOOSE_THIS_CAR);
    const cmsContent = section?.meta || {};

    const containerStyle = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.WHY_CHOOSE_THIS_CAR, STYLE_KEYS.REASONS_CONTAINER, isLuxuryCar, false);

    return (
        <div styleName={containerStyle}>
            <p styleName={"styles.heading"}>{cmsContent?.heading}</p>
            <div styleName={"styles.reasonItem"}>
                {features.map((reason, index) => (
                    <div key={index} className="media" styleName={"styles.mediaContainer"}>
                        <img src={ getFastlyImage(config, reason.image)} />
                        <div className="media-body">
                            <p styleName={"styles.reasonTextTitle"}>{reason.title}</p>
                            <p styleName={"styles.reasonTextSubTitle"}>{reason.subTitle}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
WhyChooseThisCar.propTypes = {
    reasons: PropTypes.array,
    content: PropTypes.object,
    config: PropTypes.object,
    isLuxuryCar: PropTypes.bool,
    cmsConfig: PropTypes.object
};
export default WhyChooseThisCar;
